import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InformesService {
  private isPageInforme$: Subject<boolean> = new Subject();
  private informeType$: Subject<string> = new Subject();
  private refresh$: Subject<boolean> = new Subject();
  selectedPageInforme$ = this.isPageInforme$.asObservable();
  informPbiSelected$ = this.informeType$.asObservable();
  refreshSelected$ = this.refresh$.asObservable();

  setPageInforme(pageInforme: boolean): void {
    this.isPageInforme$.next(pageInforme);
  }

  getPageInforme(): Observable<boolean> {
    return this.selectedPageInforme$;
  }

  setInformeType(type: string): void {
    this.informeType$.next(type);
  }

  getInformeType(): Observable<string> {
    return this.informPbiSelected$;
  }

  setRefresh(refresh: boolean): void {
    this.refresh$.next(refresh);
  }

  getRefresh(): Observable<boolean> {
    return this.refreshSelected$;
  }
}
